<template>
    <section class="relative flex flex-col justify-center items-center sm:py-12 lg:py-16"
        :class="{ 'text-center': center }">
        <div class="h-auto my-15">
            <h2 class="font-semibold">{{ title }}</h2>
        </div>
        <div class="m-3 w-full text-center text-neutral-50 text-xl" v-if="subtitle">
            <p>{{ subtitle }}</p>
        </div>

        <div class="flex flex-col gap-8 sm:grid"
            :class="{ 'sm:mt-15 mt-10': title, ' grid-cols-3': benefits?.length! >= 3, ' grid-cols-2': benefits?.length! < 3 }">
            <BenefitSection v-for="(benefit, index) of benefits"
                :title="benefit.title"
                :body="benefit.body"
                :center="center" :index="label ? (index + 1).toString() : undefined"
                :icon="benefit.icon"
                :image_url="benefit.image_url"
                :image_width="benefit.image_width"
                :image_height="benefit.image_height"
                :image_srcset="benefit.image_srcset"
                :image_sizes="benefit.image_sizes"
                :image_lazy="lazy_images"
                :total="String(benefits?.length)"
                :image_40="benefit.image_40"
                :bottom_image="bottom_image"
                :border="border"
                :button_text="benefit.button_text"
                :button_link="benefit.button_link"
                class="w-full sm:flex-1 sm:mx-5 sm:max-w-xs rounded-lg p-8"
                />
        </div>

        <a v-if="button_text" :href="button_link"
            class="btn btn-primary mt-8 w-full md:w-auto text-center sm:text-left">{{ button_text }}</a>
    </section>
</template>

<script lang="ts">
import { type PropType } from 'vue';

export interface IBenefit {
    title?: string;
    body?: string;
    icon?: string;
    image_url?: string;
    // Intrinsic pixel size of image_url, used to reserve layout space and avoid CLS.
    image_width?: number;
    image_height?: number;
    // Optional responsive-image srcset/sizes (see TICKET-10191).
    image_srcset?: string;
    image_sizes?: string;
    image_40?: boolean;
    index?: string;
    button_text?: string;
    button_link?: string;
};

export default {
    props: {
        title: String,
        button_text: String,
        button_link: String,
        subtitle: String,
        benefits: Array as PropType<IBenefit[]>,
        small: Boolean,
        bottom_image: Boolean,
        label: Boolean,
        center: Boolean,
        // Below-fold usages (e.g. the homepage step images, see TICKET-10191) can
        // opt into loading="lazy"/decoding="async" on each benefit's image.
        lazy_images: Boolean,
        border: {
            type: Boolean,
            default: true
        },
    },
};
</script>